import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

function SessionUnavailable({ onRetry }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-white px-6" data-testid="session-unavailable">
      <div className="max-w-sm text-center">
        <h1 className="text-lg font-semibold text-[#1F2937]">Impossibile verificare la sessione</h1>
        <p className="mt-2 text-sm text-[#6B7280]">
          Il servizio di autenticazione non risponde. Non sei stato disconnesso: riprova tra qualche istante.
        </p>
        <button
          type="button"
          onClick={onRetry}
          className="mt-4 rounded-md bg-[#0153A3] px-4 py-2 text-sm font-semibold text-white hover:bg-[#014485]"
          data-testid="session-retry-button"
        >
          Riprova
        </button>
      </div>
    </div>
  );
}

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading, authUnavailable, retrySession } = useAuth();
  const loc = useLocation();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-[#0153A3] border-t-transparent" />
      </div>
    );
  }
  // Sessione non validata: nessun contenuto protetto, ma nemmeno logout.
  if (authUnavailable) return <SessionUnavailable onRetry={retrySession} />;
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  if (adminOnly && user.role !== "ADMIN") return <Navigate to="/" replace />;
  return children;
}
